import { Reducer } from 'redux';
import produce from 'immer';
import Global from '@naruto/naruto-reducers/src/stores/global';
import GLOBAL_ACTION from '@naruto/naruto-reducers/src/reducers/global/events';
import { CreateGlobalReducerParams, GlobalActionTypes } from './types';

export function createGlobalReducer(params: CreateGlobalReducerParams): Reducer<Global, GlobalActionTypes> {
  return (state = params.initialState, action: GlobalActionTypes): Global =>
    produce(state, _draft => {
      const draft = _draft;
      switch (action.type) {
        case GLOBAL_ACTION.SET_GLOBAL_INITIALIZE:
          draft.initialize();
          break;
        case GLOBAL_ACTION.SET_GLOBAL_LOADING:
          draft.updateGlobalLoading(action.loading);
          break;
        case GLOBAL_ACTION.SET_GLOBAL_SIDE_BAR:
          draft.updateGlobalSideBar(action.open);
          break;
        case GLOBAL_ACTION.SET_GLOBAL_SIDE_BAR_STATIC:
          draft.updateGlobalSideBarStatic(action.open);
          break;
        case GLOBAL_ACTION.SET_GLOBAL_HEADER:
          draft.updateGlobalHeader(action.open);
          break;
        case GLOBAL_ACTION.SET_GLOBAL_THEME:
          draft.updateGlobalThemeVersion(action.theme);
          break;
        case GLOBAL_ACTION.SET_GLOBAL_HISTORIES:
          draft.updateGlobalHistories(action.histories);
          break;
        case GLOBAL_ACTION.SET_GLOBAL_ROLE_SELECT:
          draft.updateGlobalRoleSelect(action.select);
          break;
        case GLOBAL_ACTION.SET_GLOBAL_FONT_SCALE:
          draft.updateGlobalFontScale(action.scale);
          break;
        case GLOBAL_ACTION.SET_GLOBAL_LANG:
          draft.updateGlobalLang(action.lang);
          break;
        default:
          break;
      }
    });
}
